import { TaskDueDateOffset } from '../CRMIntegrationTaskSettings'

export type SalesforceInboundContactSyncSettings = {
  autoSync: boolean
}

export type SalesforceInboundSyncSettings = {
  contact: SalesforceInboundContactSyncSettings
}

export type SalesforceSettingsFormValues = {
  inbound: SalesforceInboundSyncSettings
  taskDueDateOffset?: TaskDueDateOffset
}

export const salesforceSettingsDefaultValues: SalesforceSettingsFormValues = {
  inbound: {
    contact: {
      autoSync: false,
    },
  },
  taskDueDateOffset: {
    value: 1,
    unit: 'weeks',
  },
}

export type BlackDiamondSettingsFormValues = {
  taskDueDateOffset?: TaskDueDateOffset
}

export const blackDiamondSettingsDefaultValues: BlackDiamondSettingsFormValues = {
  taskDueDateOffset: {
    value: 1,
    unit: 'weeks',
  },
}

export type ElementsSettingsFormValues = {
  taskDueDateOffset?: TaskDueDateOffset
}

export const elementsSettingsDefaultValues: ElementsSettingsFormValues = {
  taskDueDateOffset: {
    value: 1,
    unit: 'weeks',
  },
}

export type PractifiSettingsFormValues = {
  taskDueDateOffset?: TaskDueDateOffset
}

export const practifiSettingsDefaultValues: PractifiSettingsFormValues = {
  taskDueDateOffset: {
    value: 1,
    unit: 'weeks',
  },
}

export type XLR8SettingsFormValues = {
  taskDueDateOffset?: TaskDueDateOffset
}

export const xlr8SettingsDefaultValues: XLR8SettingsFormValues = {
  taskDueDateOffset: {
    value: 1,
    unit: 'weeks',
  },
}
